import { useState, useEffect } from "react";
import useGroupMembers from "./useGroupMembers"; // Hook que lista membros do grupo ou canal

const useIsMember = (groupId, userEmail, channelId = null) => {
    const { members, loading, error } = useGroupMembers(groupId, channelId); // Passa o channelId opcionalmente
    const [isMember, setIsMember] = useState(false);
    const [finished, setFinished] = useState(false); // Novo estado para indicar que a verificação foi concluída

    useEffect(() => {
        if (!loading && !error && userEmail) {
            const member = members.find(
                (member) => member.email.toLowerCase() === userEmail.toLowerCase()
            );
            setIsMember(!!member);
            setFinished(true); // Marca a verificação como concluída
        } else if (!loading && error) {
            setFinished(true); // Marca como concluída mesmo em caso de erro
        }
    }, [members, loading, error, userEmail]);

    return { isMember, loading: loading || !finished, error }; // Retorna `loading` como `true` enquanto não estiver finalizado
};

export default useIsMember;
